import { httpGet, httpPost } from './httpClient';

export const webApi = {
  async getTasks() {
    return httpGet('/tasks/get-tasks.php');
  },

  async addTask(task) {
    return httpPost('/tasks/add-task.php', task);
  },

  async updateTask(task) {
    return httpPost('/tasks/update-task.php', task);
  },

  async deleteTask(id) {
    return httpPost('/tasks/delete-task.php', { id });
  },

  async reorderTasks(items) {
    return httpPost('/tasks/reorder-tasks.php', { items });
  },

  async login(login, password) {
    return httpPost('/auth/login.php', { login, password });
  },

  async logout() {
    return httpPost('/auth/logout.php', {});
  },

  async sessionCheck() {
    return httpGet('/auth/session-check.php');
  },

  async getLedgerRows(month) {
    return httpGet('/ledger/get-rows.php', `?month=${encodeURIComponent(month)}`);
  },

  async addLedgerRow(row) {
    return httpPost('/ledger/add-row.php', row);
  },

  async updateLedgerRow(row) {
    return httpPost('/ledger/update-row.php', row);
  },

  async deleteLedgerRow(id) {
    return httpPost('/ledger/delete-row.php', { id });
  },

  async toggleLedgerExclusion(id, exclu) {
    return httpPost('/ledger/toggle-exclusion.php', { id, exclu });
  },

  async reorderLedgerRows(items) {
    return httpPost('/ledger/reorder-rows.php', { items });
  },
};

export function ensureWebApiOnWindow() {
  if (typeof window === 'undefined') return;
  if (!window.api) {
    window.api = webApi;
  }
}
